module.exports = __webpack_public_path__ + "static/media/netlify.09b5a31a.svg";